import { formatCurrency } from '@/lib/display'

export const buildNtsByEmployeeExport = ({ items, headers }) => {
  const keys = headers.map(header => header.value)
  const data = items.map(item => {
    const row = {}
    keys.forEach(key => {
      row[key] = key === 'individualGrossProfit'
        ? formatCurrency(item[key])
        : item[key]
    })
    return row
  })

  return {
    title: headers.map(header => header.text),
    key: keys,
    data,
    autoWidthFlag: true,
    filename: 'NTS by Employee'
  }
}
